<div class="flex flex-row items-center justify-between p-3 relative w-full">
    <div class="flex flex-row items-center justify-between w-full">
        <ng-content></ng-content>
    </div>
</div>
